module.exports = __webpack_public_path__ + "img/coupon_entry.f10ddb0b.png";